@if (gladlyHelpCenterEnabled) {
  <div [id]="gladlyDivSelector"></div>
}
<referral-popup></referral-popup>
